import React from 'react';

const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
  >
    <path
      d="M8.375 8.125C8.375 8.32391 8.29598 8.51468 8.15533 8.65533C8.01468 8.79598 7.82391 8.875 7.625 8.875H1.625C1.42609 8.875 1.23532 8.79598 1.09467 8.65533C0.954018 8.51468 0.875 8.32391 0.875 8.125V2.125C0.875 1.92609 0.954018 1.73532 1.09467 1.59467C1.23532 1.45402 1.42609 1.375 1.625 1.375H7.625C7.82391 1.375 8.01468 1.45402 8.15533 1.59467C8.29598 1.73532 8.375 1.92609 8.375 2.125V8.125Z"
      stroke="#01619B"
    />
    <path
      d="M18.125 8.125C18.125 8.32391 18.046 8.51468 17.9053 8.65533C17.7647 8.79598 17.5739 8.875 17.375 8.875H11.375C11.1761 8.875 10.9853 8.79598 10.8447 8.65533C10.704 8.51468 10.625 8.32391 10.625 8.125V2.125C10.625 1.92609 10.704 1.73532 10.8447 1.59467C10.9853 1.45402 11.1761 1.375 11.375 1.375H17.375C17.5739 1.375 17.7647 1.45402 17.9053 1.59467C18.046 1.73532 18.125 1.92609 18.125 2.125V8.125Z"
      stroke="#01619B"
    />
    <path
      d="M8.375 17.875C8.375 18.0739 8.29598 18.2647 8.15533 18.4053C8.01468 18.546 7.82391 18.625 7.625 18.625H1.625C1.42609 18.625 1.23532 18.546 1.09467 18.4053C0.954018 18.2647 0.875 18.0739 0.875 17.875V11.875C0.875 11.6761 0.954018 11.4853 1.09467 11.3447C1.23532 11.204 1.42609 11.125 1.625 11.125H7.625C7.82391 11.125 8.01468 11.204 8.15533 11.3447C8.29598 11.4853 8.375 11.6761 8.375 11.875V17.875Z"
      stroke="#01619B"
    />
    <path
      d="M18.125 17.875C18.125 18.0739 18.046 18.2647 17.9053 18.4053C17.7647 18.546 17.5739 18.625 17.375 18.625H11.375C11.1761 18.625 10.9853 18.546 10.8447 18.4053C10.704 18.2647 10.625 18.0739 10.625 17.875V11.875C10.625 11.6761 10.704 11.4853 10.8447 11.3447C10.9853 11.204 11.1761 11.125 11.375 11.125H17.375C17.5739 11.125 17.7647 11.204 17.9053 11.3447C18.046 11.4853 18.125 11.6761 18.125 11.875V17.875Z"
      stroke="#01619B"
    />
  </svg>
);

export default DashboardIcon;
